import { FilterResult } from "../../types/api";
import { useI18n } from "../../i18n";

interface FilterResultsProps {
  filterResult: FilterResult;
  hasActiveFilters: boolean;
}

export default function FilterResults({
  filterResult,
  hasActiveFilters,
}: FilterResultsProps) {
  const { t } = useI18n();
  const { filteredCount, totalCount } = filterResult;

  if (!hasActiveFilters) {
    return (
      <div className="text-sm mb-6 flex items-center gap-2">
        {t("filterResults.showingAll", { count: totalCount })}
      </div>
    );
  }

  if (filteredCount === 0) {
    return (
      <div className="hero bg-base-200 rounded-box p-8 sm:p-12 mb-6">
        <div className="hero-content text-center">
          <div>
            <h3 className="text-lg font-medium mb-2">
              {t("filterResults.noMatch")}
            </h3>
            <p className="opacity-70 max-w-sm">
              {t("filterResults.noMatchBody")}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="alert alert-info mb-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 flex-1">
        <div className="flex items-center gap-2">
          <span>
            {t("filterResults.showingOf", {
              filtered: filteredCount,
              total: totalCount,
            })}
          </span>
        </div>
        <div className="badge badge-accent">
          {t("filterResults.filteredBadge")}
        </div>
      </div>
    </div>
  );
}
